import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import { IncludeCodeHandler } from './include-code-handler';
import CodeComponent from "./code-component.vue";

export const codeFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(CodeComponent)
    .whenTargetNamed("code");

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeCodeHandler);
});
